import { render, staticRenderFns } from "./Vol02.vue?vue&type=template&id=d6170ed2&scoped=true&"
import script from "./Vol02.vue?vue&type=script&lang=js&"
export * from "./Vol02.vue?vue&type=script&lang=js&"
import style0 from "./Vol02.vue?vue&type=style&index=0&id=d6170ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6170ed2",
  null
  
)

export default component.exports